import { render, staticRenderFns } from "./QueueStatus.vue?vue&type=template&id=e6516514&"
import script from "./QueueStatus.vue?vue&type=script&lang=ts&"
export * from "./QueueStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports